'use client'

import S from './ForClubsHeroImageLayers.module.scss'

type ForClubsHeroImageLayersProps = {
  omitGrain?: boolean
}

const ForClubsHeroImageLayers = ({
  omitGrain
}: ForClubsHeroImageLayersProps) => {
  return (
    <>
      <div className={S.darken} aria-hidden />
      {!omitGrain && <div className={S.grainNoise} aria-hidden />}
      <div className={S.bottomBlend} aria-hidden />
    </>
  )
}

export default ForClubsHeroImageLayers
